import { isEmpty } from 'lodash';
import { toast } from 'src/utils';
import { BACKEND_HTTP_PATH } from 'src/config';
import { C_SEND_FRONT_LOGS_ENABLE, C_PERIOD_SEND_FRONT_LOGS } from 'src/store/modules/app';
import i18n from 'src/features/i18n';

// в константы выносим только названия свойств/мутаций,
// которые переиспользуем/планируем переиспользовать
export const С_FRONT_LOGS = 'С_FRONT_LOGS';
export const SET_STOPPED_SENDING_LOGS = 'SET_STOPPED_SENDING_LOGS';

function notificateError(value) {
  if (value) {
    toast.error({
      msg: i18n.t('T_DEBUG_INFO_NOT_SENT'),
    });
  }
}

function notificateSuccess(value) {
  if (value) {
    toast.success({
      msg: i18n.t('T_DEBUG_INFO_SENT'),
    });
  }
}

const positiveNegative = () => Math.round(Math.random()) * 2 - 1;
const randomInterval = () => Math.random() * 1000 * 9 * positiveNegative();
const interval = (rootState) => rootState.app[C_PERIOD_SEND_FRONT_LOGS] + randomInterval();
let logsTimer = null;

const data = {
  [С_FRONT_LOGS]: [],
  timestampLast: null,
  userInfo: {
    id: null,
    name: null,
    role: null,
  },
  stoppedSendingLogs: false,
};

const actions = {
  setLogsAndUserInfo({ commit, rootState }, value) {
    const user = {
      id: rootState.user.id,
      name: rootState.user.username,
      role: rootState.user.role,
    };
    commit('SET_USER_INFO', user);
    commit('SET_LOGS', value);
  },
  sendLogs({
    state, commit, rootState,
  }, { timestamp = null, notificate = false } = {}) {
    if (!rootState.app[C_SEND_FRONT_LOGS_ENABLE]) return false;
    const currentTimestamp = timestamp || new Date().getTime();
    if ((state.timestampLast && state.timestampLast > currentTimestamp) || isEmpty(state[С_FRONT_LOGS])) return false;
    const xhr = new XMLHttpRequest();
    xhr.open('POST', `${BACKEND_HTTP_PATH}frontend-log-collector`, true);
    xhr.onload = () => {
      if (xhr.status === 200) {
        commit('EMPTY_LOGS');
        commit('SET_TIMESTAMP', null);
        notificateSuccess(notificate);
      } else {
        notificateError(notificate);
      }
    };
    xhr.onerror = () => {
      notificateError(notificate);
    };
    const formattedLogs = JSON.stringify(state[С_FRONT_LOGS]);
    xhr.send(formattedLogs);

    return true;
  },
  runLoopSendingLogs({ state, dispatch }) {
    if (state.stoppedSendingLogs) return;
    dispatch('sendLogs');
    dispatch('loopSendingLogs');
  },
  loopSendingLogs({ rootState, dispatch }) {
    logsTimer = setTimeout(() => {
      dispatch('runLoopSendingLogs');
    }, interval(rootState));
  },
  startSendingLogs({ dispatch, commit }) {
    commit(SET_STOPPED_SENDING_LOGS, false);
    dispatch('loopSendingLogs');
  },
  stopSendingLogs({ commit }) {
    commit(SET_STOPPED_SENDING_LOGS, true);
    clearTimeout(logsTimer);
  },
  notificatedSendLogs({ dispatch }) {
    dispatch('sendLogs', { notificate: true }).then((res) => {
      if (res) {
        toast.info({
          msg: i18n.t('T_DEBUG_INFO_SENDING'),
        });
      } else {
        toast.warning({
          msg: i18n.t('T_DEBUG_INFO_DONT_SENDING'),
        });
      }
    });
  },
};

const mutations = {
  SET_STOPPED_SENDING_LOGS(state, value) {
    state.stoppedSendingLogs = value;
  },
  SET_LOGS(state, value) {
    if (state[С_FRONT_LOGS].length) {
      const firstLogDate = state[С_FRONT_LOGS][0].date;
      const now = new Date();
      if (now - firstLogDate > 600000) {
        state[С_FRONT_LOGS].shift();
      }
    }
    const lastElem = state[С_FRONT_LOGS][state[С_FRONT_LOGS].length];
    if (lastElem && lastElem.text === value.text
      && value.text - lastElem.date < 1000) return;
    const fullString = {
      userInfo: state.userInfo,
      ...value,
    };
    state[С_FRONT_LOGS].push(fullString);
  },
  EMPTY_LOGS(state) {
    state[С_FRONT_LOGS] = [];
  },
  SET_TIMESTAMP(state, value) {
    state.timestampLast = value;
  },
  SET_USER_INFO(state, value) {
    state.userInfo = value;
  },
};

const store = {
  namespaced: true,
  state: data,
  actions,
  mutations,
};

export default store;
